var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('block-image-content-grid');
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { Grid } from '../elements/grid';
import { BlockImageContent } from './block-image-content';
export var BlockImageContentGridDefaultProps = {
  items: [],
  tabletAutoColumns: 3,
  desktopAutoColumns: 3
};
// -------- Styles -------->
var GridStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n  "], ["\n    flex: 1;\n  "])))
});
// -------- Components -------->
var My = {
  Grid: styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Item: styled(BlockImageContent)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var BlockImageContentGrid = function (props) {
  var className = props.className,
    items = props.items,
    rest = __rest(props, ["className", "items"]);
  return React.createElement(My.Grid, __assign({
    className: cls.name(className)
  }, rest, {
    items: items.map(function (item) {
      return React.createElement(My.Item, {
        key: item.id,
        entity: item
      });
    })
  }));
};
BlockImageContentGrid.defaultProps = BlockImageContentGridDefaultProps;
BlockImageContentGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;